import { HtmlElementView } from './html-element-view.js';
import { MainView, ErrorDetailsView } from './interfaces.js';

export class ErrorDetails extends HtmlElementView implements ErrorDetailsView {
  constructor(
    readonly section: HTMLElement,
    readonly errorMessage: HTMLSpanElement,
    readonly resetButton: HTMLButtonElement,
    readonly viewList: MainView,
  ) {
    super(section);
    this.bindResetButton();
  }

  private bindResetButton() {
    this.resetButton.addEventListener('click', () => {
      this.viewList.resetPassphraseForm();
      this.hide();
      this.viewList.showPassphraseForm();
    });
  }

  setErrorMessage(message: string): void {
    this.errorMessage.textContent = message;
  }

  disableResetButton() {
    this.resetButton.classList.add('hidden');
    this.resetButton.disabled = true;
  }
}
